import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IOAuth2Client } from "@sso/oauth2-clients/contracts";
import { NormalPaginated } from "@types";
import { IFilteredColumn } from "@funcional/react-table-ui";
import { useSsoOAuth2Url } from "@common/hooks/useSsoOauth2Url";

export interface OAuthClientFilter {
  id?: string[];
  name?: string[];
}

export interface UseOAuth2ClientsOptions {
  gridFilters?: IFilteredColumn[];
  filter?: OAuthClientFilter;
}

export function useOAuth2Clients(
  options: UseOAuth2ClientsOptions | undefined = {}
) {
  const { request } = useSsoOAuth2Url();
  if (options.gridFilters) {
    const filter: OAuthClientFilter = options.filter || {};
    options.gridFilters.forEach((filteredColumn: any) => {
      if (filteredColumn.id === "id") filter.id = filteredColumn.value;
      if (filteredColumn.id === "name") filter.name = filteredColumn.value;
    });
    options.filter = filter;
  }
  return useQuery("oauth2clients" + JSON.stringify(options), async () => {
    const { oAuthClients } = await request(
      gql`
        query oAuthClients($filter: OAuthClientFilter) {
          oAuthClients(filter: $filter, limit: 10) {
            data {
              id
              secret
              name
              type
              redirects
              revoked
              tokenExpiration
              user {
                uuid
                name
              }
            }
          }
        }
      `,
      options
    );
    return oAuthClients as NormalPaginated<IOAuth2Client>;
  });
}
